import axios from "axios";

const BASE_URL = "/api/admin/grievance"; 

const axiosConfig = {
    withCredentials: true, 
    headers: {
        "Content-Type": "application/json"
    }
};

const fetchGrievanceList = async (projectId, filters, page = 1, limit = 20) => {
    try {
        const payload = {
            projectId, // Mandatory for the backend middleware
            ...filters,
            page,
            limit
        };

        // We use POST for listing to handle complex filter objects easily
        const response = await axios.post(`${BASE_URL}/list`, payload, axiosConfig);
        
        // Backend returns: { status: true, data: { data: [...], pagination: {...} } }
        if(response.data.status === false) {
             throw new Error(response.data.message || "Failed to fetch list");
        }
        
        return response.data; 
    } catch (error) {
        console.error("Error fetching grievances:", error);
        throw error;
    }
};
const getGrievanceDetails = async (projectId, grievanceId) => {
    try {
        const payload = {
            projectId,   // Required by your backend middleware
            grievanceId
        };
        // Using POST to maintain consistency with your other endpoints
        const response = await axios.post(`${BASE_URL}/detail`, payload, axiosConfig);
        return response.data;
    } catch (error) {
        console.error("Error fetching grievance details:", error);
        throw error;
    }
};

const takeDecision = async (projectId, grievanceIds, action, rejectionReason = null) => {
    try {
        const payload = {
            projectId, // Mandatory
            grievanceIds,
            action, // 'accept' or 'reject' or 'resolved'
            rejectionReason
        };
        const response = await axios.post(`${BASE_URL}/decision`, payload, axiosConfig);
        return response.data;
    } catch (error) {
        console.error("Error updating grievance status:", error);
        throw error;
    }
};

const getProjectLocations = async (projectId) => {
    try {
        const payload = { projectId };
        const response = await axios.post(`${BASE_URL}/settings/getlocations`, payload, axiosConfig);
        return response.data;
    } catch (error) {
        console.error("Error fetching locations:", error);
        throw error;
    }
};
const getGrievanceCategories = async (projectId) => {
    try {
        // Even though the list is static, we send projectId to pass middleware checks
        const payload = { projectId };
        const response = await axios.post(`${BASE_URL}/settings/getcategories`, payload, axiosConfig);
        return response.data;
    } catch (error) {
        console.error("Error fetching categories:", error);
        throw error;
    }
};
const getGrievanceMetadata = async (projectId) => {
    try {
        const payload = { projectId };
        const response = await axios.post(
            `${BASE_URL}/settings/metadata`,
            payload,
            axiosConfig
        );
        return response.data;
    } catch (error) {
        console.error("Error fetching grievance metadata:", error);
        throw error;
    }
};
const getStates = async (projectId, countryCode = "IN") => {
    try {
        const payload = { projectId, countryCode };
        const response = await axios.post(
            `${BASE_URL}/settings/getstates`,
            payload,
            axiosConfig
        );
        return response.data; // { status, data: [ { name, isoCode }, ... ] }
    } catch (error) {
        console.error("Error fetching states:", error);
        throw error;
    }
};

const getCitiesForState = async (projectId, stateCode, countryCode = "IN") => {
    try {
        const payload = { projectId, countryCode, stateCode };
        const response = await axios.post(
            `${BASE_URL}/settings/getcities`,
            payload,
            axiosConfig
        );
        return response.data; // { status, data: [ { name }, ... ] }
    } catch (error) {
        console.error("Error fetching cities for state:", error);
        throw error;
    }
};

const saveProjectCities = async (projectId, payload) => {
    try {
        // payload = { state, state_iso, allowed_cities: ['Delhi', 'Noida'] }
        const body = { projectId, ...payload };
        const response = await axios.post(
            `${BASE_URL}/settings/saveprojectcities`,
            body,
            axiosConfig
        );
        return response.data; // { status, data, message }
    } catch (error) {
        console.error("Error saving project cities:", error);
        throw error;
    }
};
const deleteProjectState = async (projectId, state) => {
    try {
        const payload = { projectId, state };
        const response = await axios.post(
            `${BASE_URL}/settings/deleteprojectstate`,
            payload,
            axiosConfig
        );
        return response.data;
    } catch (error) {
        console.error("Error deleting project state:", error);
        throw error;
    }
};
const updateUserGrievanceStatus = async (user_id, status) => {
    try {
        const response = await axios.post('/api/admin/grievance/update-user-grievance-status', { 
            user_id, 
            status 
        });
        return response.data;
    } catch (error) {
        console.log('Error updating status:', error);
        throw error;
    }
};

export default {
    fetchGrievanceList,
    takeDecision,
    getProjectLocations,
    getGrievanceDetails,
    getGrievanceCategories,
    getGrievanceMetadata,
    getStates,
    getCitiesForState,
    saveProjectCities,
    deleteProjectState,
    updateUserGrievanceStatus
};